import { useMutation, useQuery } from "@tanstack/react-query"
import { getFeedWebByFeedId, updateFeedWeb } from "../../../../../service/feed"

type myFeedBottomSheetValue = 'isShow' | 'edit' | 'delete'

interface IMyFeedBottomSheet extends IBottomSheet {
    value: myFeedBottomSheetValue
}

const myFeedBottomSheetDataList: IMyFeedBottomSheet[] = [
    {
        id: 0,
        label: '나만 보기',
        value: 'isShow',
    },
    {
        id: 1,
        label: '수정',
        value: 'edit',
    },
    {
        id: 2,
        label: '삭제',
        value: 'delete',
    }
]

const useUpdateFeedWeb = () => {
    const mutation = useMutation({ mutationFn: updateFeedWeb })

    return mutation;
}

const useGetFeedWebByFeedId = (id: number, requestQuery?: string) => {
    const query = useQuery({
        queryKey: ['getFeedWebByFeedId', id],
        queryFn: () => getFeedWebByFeedId(id, requestQuery),
        select: res => res.data.data.getFeedWebByFeedId
    })

    return query;
}



export { myFeedBottomSheetDataList, useUpdateFeedWeb, useGetFeedWebByFeedId }